import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { AdvancedAnalyticsServices } from '../../advanced-analytics-services';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';

/**
 * Generated class for the StockElementPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-stock-cost-evolution',
  templateUrl: 'stock-cost-evolution.html',
})
export class StockCostEvolutionPage {

  chartData: any;
  chartLabels: any;
  chartCheck: any;
  element: any;
  //datatable
  result: any;

  rows = [];
  temp = [];
  columns = [
    { prop: 'date', name: this.translate.instant('general-fecha') },
    { prop: 'value', name: this.translate.instant('general-precio') + ' (' + this.globals.currency_symbol + ')' },

  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public modalCtrl: ModalController) {
    this.element = this.navParams.get('element');
    this.getAnalyticsData(this.element);
  }


  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('analytics-titulo-fechas'),
      date_first: this.advancedAnalyticsServices.date1,
      date_last: this.advancedAnalyticsServices.date2,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.advancedAnalyticsServices.date1 = data.date_first;
        this.advancedAnalyticsServices.date2 = data.date_last;
        //
        this.getAnalyticsData(this.element);
      }
    });
    profileModal.present();
  }


  public _ingredient_cost_last_months: any = 0;
  public ingredient_cost_state = '';
  public ingredient_cost_percent: any; //mostraremos el procentaje en la view
  public _ingredient_foodcost = 0;

  async getAnalyticsData(element) {
    var type = 'ingredient_price';

    if (element.type == 'product') {
      type = 'product_cost'
    }

    const params = new HttpParams()
      .set('public_key', this.globals.restaurant_uid)
      .set('product_name', element.name)
      .set('type', type)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'));

    this.chartCheck = false;
    this.http.post(this.globals.analytics_path + 'analytics/stock_cost_evolution', params, {})
      .subscribe(async response => {
        //chart
        this.rows = response['list'];
        this.temp = response['list'];
        this._ingredient_cost_last_months = response['result'];
        this.chartLabels = response['stock_data']['data']; //total's
        this.chartData = response['stock_data']['labels'];//Dates
        this.chartCheck = true;//boolean check

        if (this.element.sub_recipe) {
          this._ingredient_foodcost = this.element.price_static / this.element.real_weight; // calculamos foodcost del dish
        } else {
          this._ingredient_foodcost = this.element.price_static / 1; // calculamos foodcost del dish
        }

        this.ingredient_cost_percent = 100 - this.globals.regla3(this._ingredient_cost_last_months, this._ingredient_foodcost);

        if (this._ingredient_cost_last_months > this._ingredient_foodcost) {
          this.ingredient_cost_state = 'positive';
        } else {
          this.ingredient_cost_state = 'negative';
          this.ingredient_cost_percent = Math.abs(this.ingredient_cost_percent);
        }
      });
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.date.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

}



// WEBPACK FOOTER //
// ./src/pages/analytics/reports/stock-cost-evolution/stock-cost-evolution.ts